module.exports = __webpack_public_path__ + "img/size.d93cc8f3.jpg";